import { render, staticRenderFns } from "./AllLotList.vue?vue&type=template&id=2716a20f&scoped=true"
import script from "./AllLotList.vue?vue&type=script&lang=js"
export * from "./AllLotList.vue?vue&type=script&lang=js"
import style0 from "./AllLotList.vue?vue&type=style&index=0&id=2716a20f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2716a20f",
  null
  
)

export default component.exports